// extracted by mini-css-extract-plugin
export default {"sectionTitle":"EventsPage_sectionTitle__1OCgl","sectionTitlePast":"EventsPage_sectionTitlePast__Qo8it"};